import { createContext } from 'react';

type LoginContextType = {
  email: string;
  setEmail: (arg0: string) => void;
  desiredDestination: string | null | undefined;
  setDesiredDestination: (arg0: string) => void;
};

export const LoginContext = createContext<LoginContextType>({
  email: '',
  setEmail: () => {},
  desiredDestination: null,
  setDesiredDestination: () => {},
});
